import { PencilIcon } from '@heroicons/react/outline'
import { HTMLAttributes } from 'react'
import {
  ColorProps,
  MarginProps,
  PositionProps,
  SpaceProps,
} from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import {
  Adjustments,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Bookmark,
  Building,
  Cash,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  Close,
  DotsHorizontal,
  DotsVertical,
  Download,
  ExclamationCircle,
  ExternalLink,
  Info,
  Mail,
  Menu,
  Minus,
  MinusSmall,
  Phone,
  Plus,
  PlusSmall,
  Printer,
  Search,
  Settings,
  Sparkles,
  Support,
  SwapHorizontal,
  SwapVertical,
  Trash,
  Upload,
} from '../../assets/icons'
import { COLOR } from 'designSystem/foundations/constants/color'

import PDSBox from '../PDSBox/PDSBox'

export type IconName = keyof typeof ICONS
export type IconSize = 'sm' | 'md' | 'lg'

type BaseProps = HTMLAttributes<HTMLDivElement> &
  ColorProps &
  MarginProps &
  PositionProps &
  SpaceProps &
  TestIdProps

type Props = {
  name: IconName
  size?: IconSize
} & BaseProps

export default function PDSIcon({
  color = COLOR.grey500,
  name,
  size = 'sm',
  testId,
  ...props
}: Props) {
  const IconComponent = ICONS[name]
  const iconSize = ICON_SIZE[size]

  return (
    <PDSBox
      {...props}
      color={color}
      height={iconSize}
      testId={testId}
      width={iconSize}
    >
      {IconComponent && (
        <IconComponent color={color} height={iconSize} width={iconSize} />
      )}
    </PDSBox>
  )
}

const ICONS = {
  adjustments: Adjustments,
  arrowDown: ArrowDown,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  arrowUp: ArrowUp,
  bookmark: Bookmark,
  building: Building,
  cash: Cash,
  check: Check,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  clock: Clock,
  close: Close,
  dotsHorizontal: DotsHorizontal,
  dotsVertical: DotsVertical,
  download: Download,
  exclamationCircle: ExclamationCircle,
  externalLink: ExternalLink,
  info: Info,
  mail: Mail,
  menu: Menu,
  minus: Minus,
  minusSmall: MinusSmall,
  pencil: PencilIcon,
  phone: Phone,
  plus: Plus,
  plusSmall: PlusSmall,
  printer: Printer,
  search: Search,
  settings: Settings,
  sparkles: Sparkles,
  support: Support,
  swapHorizontal: SwapHorizontal,
  swapVertical: SwapVertical,
  trash: Trash,
  upload: Upload,
}

const ICON_SIZE = {
  sm: '1rem',
  md: '1.5rem',
  lg: '2rem',
}
